import React from "react";

export function Section({ className = '', children }: any) {
    return <section className={`section ${className}`}>{children}</section>;
}